// Real CPL API — calls /api/V1/Cpl/* (built in Phase 2). Signatures mirror
// cplMock.ts so api/index.ts can swap mock ↔ real with one switch. Not
// exercised until VITE_USE_MOCK is off and the backend endpoints exist.

import { postJson } from './http';
import type {
  AgentInfo,
  CplDetail,
  CplFormValues,
  CplListParams,
  CplSummary,
  FormType,
  SaveResult,
  StateOption,
} from '@/types/api';

const API = '/api/V1';

export const cplRealApi = {
  async getCplFormTypes(): Promise<FormType[]> {
    const res = await postJson<{ err: string; data?: FormType[] }>(`${API}/Cpl/FormTypes`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async getCplStates(): Promise<StateOption[]> {
    const res = await postJson<{ err: string; data?: StateOption[] }>(`${API}/Cpl/States`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async getCplCounties(): Promise<string[]> {
    const res = await postJson<{ err: string; data?: string[] }>(`${API}/Cpl/Counties`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async getCplAgent(): Promise<AgentInfo> {
    const res = await postJson<{ err: string; data?: AgentInfo }>(`${API}/Cpl/Agent`);
    if (res.err !== '1' || !res.data) throw new Error('Agent lookup failed');
    return res.data;
  },

  async listCpls(params: CplListParams = {}): Promise<CplSummary[]> {
    const res = await postJson<{ err: string; data?: CplSummary[] }>(`${API}/Cpl/List`, { ...params });
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },

  async getCpl(id: number): Promise<CplDetail | null> {
    const res = await postJson<{ err: string; data?: CplDetail }>(`${API}/Cpl/Get`, { id });
    return res.err === '1' && res.data ? res.data : null;
  },

  async createCpl(values: CplFormValues): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Cpl/Create`, { ...values });
  },

  async updateCpl(id: number, values: CplFormValues): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Cpl/Edit`, { id, ...values });
  },

  async voidCpl(id: number, reason: string): Promise<SaveResult> {
    return postJson<SaveResult>(`${API}/Cpl/Void`, { id, reason });
  },
};
